import React, { useState } from "react";
import { setPaymentStatusApi } from "services/api/dashboardApi";
import Typography from "@mui/material/Typography";
import MDButton from "components/MDButton";
import CircularProgress from "@mui/material/CircularProgress";
import PaymentIcon from "@mui/icons-material/Payment";

const PaymentSetUp: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const accessToken = localStorage.getItem("stmpz-token") || "";
  const businessId = localStorage.getItem("stmpz-business-id") || "";

  const handleSetUp = async () => {
    setLoading(true);
    try {
      const session = await setPaymentStatusApi(accessToken, businessId);
      if (session) {
        window.location.href = session;
      } else {
        alert("Failed to get Stripe setup URL.");
      }
    } catch (error) {
      alert("Error setting up payment.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <PaymentIcon
        color="primary"
        fontSize="large"
        sx={{ fontSize: 48, mb: 2 }}
      />
      <Typography variant="h5" fontWeight={600} gutterBottom>
        Set Up Your Subscription
      </Typography>
      <Typography variant="body1" color="text.secondary" mb={3}>
        To access the dashboard, please set up your subscription through Stripe.
        If you're on the 30 day free trial, you won't be charged until the trial
        ends and the first billing cycle begins.
      </Typography>
      <MDButton
        variant="contained"
        color="secondary"
        size="large"
        onClick={handleSetUp}
        disabled={loading}
        fullWidth
        sx={{ py: 1.5, fontWeight: 600, fontSize: 16 }}
      >
        {loading ? (
          <CircularProgress size={24} color="inherit" />
        ) : (
          "Set Up Payment"
        )}
      </MDButton>
    </>
  );
};

export default PaymentSetUp;
